var ConnectionPrefix;
(function (ConnectionPrefix) {
    ConnectionPrefix["Lobby"] = "Lobby";
    ConnectionPrefix["Game"] = "Game";
})(ConnectionPrefix || (ConnectionPrefix = {}));
var GameLiveConnectionMethod;
(function (GameLiveConnectionMethod) {
    GameLiveConnectionMethod["GetInitialState"] = "GetInitialState";
    GameLiveConnectionMethod["Ping"] = "Ping";
    GameLiveConnectionMethod["GetInitialStateResult"] = "GetInitialStateResult";
    GameLiveConnectionMethod["DoBetResult"] = "DoBetResult";
    GameLiveConnectionMethod["FreeBetEnded"] = "FreeBetEnded";
    GameLiveConnectionMethod["DoBetResultValidation"] = "DoBetResultValidation";
    GameLiveConnectionMethod["RoundFinished"] = "RoundFinished";
    GameLiveConnectionMethod["RoundStarted"] = "RoundStarted";
    GameLiveConnectionMethod["ResultReport"] = "ResultReport";
    GameLiveConnectionMethod["DoBet"] = "DoBet";
    GameLiveConnectionMethod["CashOutResult"] = "CashoutResult";
    GameLiveConnectionMethod["MaintenanceNotify"] = "MaintenanceNotify";
    GameLiveConnectionMethod["BalanceUpdate"] = "BalanceUpdate";
    GameLiveConnectionMethod["BetsClosed"] = "BetsClosed";
    GameLiveConnectionMethod["UserTournamentInfo"] = "UserTournamentInfo";
    GameLiveConnectionMethod["GameOpen"] = "GameOpen";
    GameLiveConnectionMethod["FreeBetCountUpdate"] = "FreeBetCountUpdate";
    GameLiveConnectionMethod["GetBalance"] = "GetBalance";
    GameLiveConnectionMethod["GetBalanceResult"] = "GetBalanceResult";
    GameLiveConnectionMethod["GetUserBetsHistory"] = "GetUserBetsHistory";
    GameLiveConnectionMethod["GetUserBetsHistoryResult"] = "GetUserBetsHistoryResult";
    GameLiveConnectionMethod["AutoCashOutResultReport"] = "AutoCashoutResultReport";
})(GameLiveConnectionMethod || (GameLiveConnectionMethod = {}));
var LobbyLiveConnectionMethod;
(function (LobbyLiveConnectionMethod) {
    LobbyLiveConnectionMethod["GetInitialState"] = "GetInitialState";
    LobbyLiveConnectionMethod["GetInitialStateResult"] = "GetInitialStateResult";
    LobbyLiveConnectionMethod["RoundFinished"] = "RoundFinished";
    LobbyLiveConnectionMethod["MaintenanceNotify"] = "MaintenanceNotify";
})(LobbyLiveConnectionMethod || (LobbyLiveConnectionMethod = {}));
var CommonConnectionsMethod;
(function (CommonConnectionsMethod) {
    CommonConnectionsMethod["Reconnecting"] = "Reconnect";
    CommonConnectionsMethod["Reconnected"] = "Reconnected";
    CommonConnectionsMethod["FreeBetAwarded"] = "FreeBetAwarded";
    CommonConnectionsMethod["ConnectionClose"] = "ConnectionClose";
    CommonConnectionsMethod["UnderMaintenance"] = "UnderMaintenance";
    CommonConnectionsMethod["LobbyUsersCount"] = "LobbyUsersCount";
})(CommonConnectionsMethod || (CommonConnectionsMethod = {}));

export { CommonConnectionsMethod, ConnectionPrefix, GameLiveConnectionMethod, LobbyLiveConnectionMethod };
